import FuturaIcon from "./FuturaIcon";

const ProgressRing = ({ value, label, icon: Icon, color }) => {
  const radius = 38;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (value / 100) * circumference;

  return (
    <div className="flex flex-col items-center gap-3" data-testid={`metric-${label}`}>
      <div className="relative w-24 h-24">
        <svg className="w-24 h-24 -rotate-90" viewBox="0 0 96 96">
          <circle cx="48" cy="48" r={radius} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="6" />
          <circle cx="48" cy="48" r={radius} fill="none" stroke={color} strokeWidth="6" strokeLinecap="round" strokeDasharray={circumference} strokeDashoffset={offset} className="transition-all duration-1000 ease-out" />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <Icon className="w-4 h-4 mb-0.5" style={{ color }} />
          <span className="text-lg font-bold text-white">{value}%</span>
        </div>
      </div>
      <span className="text-xs text-white/50 text-center leading-tight">{label}</span>
    </div>
  );
};

const ChatMessage = ({ msg }) => (
  <div className={`flex ${msg.role === "user" ? "justify-end" : "justify-start"} animate-fade-in`}>
    <div className={`max-w-[80%] px-6 py-4 rounded-3xl ${
      msg.role === "user"
        ? "bg-gradient-to-r from-[#002FA7] to-[#5B21B6] text-white"
        : "bg-white/5 border border-white/10 text-white/90"
    }`}>
      {msg.role === "ai" && (
        <div className="flex items-center gap-2 mb-2">
          <FuturaIcon className="w-4 h-4 text-[#002FA7]" />
          <span className="text-xs font-medium text-white/50">FUTURA</span>
        </div>
      )}
      <p className="leading-relaxed">{msg.text}</p>
    </div>
  </div>
);

const ProgressBar = ({ current, total, t }) => (
  <div className="mb-8">
    <div className="flex items-center justify-between mb-2">
      <span className="text-sm text-white/50">{t("consulta_question_of", { current, total })}</span>
      <span className="text-sm text-white/50">{Math.round((current / total) * 100)}%</span>
    </div>
    <div className="h-1.5 bg-white/10 rounded-full overflow-hidden">
      <div
        className="h-full bg-gradient-to-r from-[#002FA7] to-[#5B21B6] rounded-full transition-all duration-500"
        style={{ width: `${(current / total) * 100}%` }}
      />
    </div>
  </div>
);

export { ProgressRing, ChatMessage, ProgressBar };
